<template>
    <div>
        <div class="backdrop active"></div>
        <div class="modal accept-bet active ticket-check modalTicketAnimation modal-location-top"
        style="color: #fff;" ref_testcafe="acceptedMultipleDrawBetModal">
            <div class="tcheck-header">
                <p class="tcheck-number-text">{{$t('LISTOFCREATEDTICKETS')}}</p>
                <div class="modal-close" v-on:click="$emit('close')">
                    <div class="icon-default icon-close"/>
                </div>
            </div>
            <div class="tcheck-event tcheck-event-main tickets-createdlist" ref_testcafe="createdTicketContainer">
                <div v-for="ticket of tickets"
                class="createdticket-single"
                :key="ticket.ticketCode">
                    <div class="icon-default icon-betslip" />
                    <p>{{
                        $t(
                            'TICKETDRAWDATE',
                            {
                                date: $options.filters.getLocalDate(ticket.selections.data[0].timestampEvent),
                            },
                        )
                    }}</p>
                    <p>{{$t('TICKETID')}}: {{ticket.code}}</p>
                    <a @click="setTicketData({
                        data: ticket,
                        error: false,
                        notice: 'SUCCESS',
                    })"
                    class="button-grey-first button">
                        {{$t('VIEWTICKET')}}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'Footer',
    props: [
        'tickets',
    ],
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
    },
    methods:
    {
        ...mapActions([
            'setTicketData',
        ]),
    },
};
</script>
